import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-header border-0 pt-5"
}
const _hoisted_2 = { class: "card-title align-items-center" }
const _hoisted_3 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Unanswered Questions", -1)
const _hoisted_5 = {
  key: 0,
  class: "alert alert-danger mb-5"
}
const _hoisted_6 = { class: "alert alert-primary d-flex align-items-center mb-5" }
const _hoisted_7 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" These are questions your AI could not answer from its Knowledge Base. Add the missing information on the ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" tab, then dismiss each item when you are done. ")
const _hoisted_10 = {
  key: 1,
  class: "text-center py-10 text-muted"
}
const _hoisted_11 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_12 = { class: "table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3" }
const _hoisted_13 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bold text-muted" }, [
    /*#__PURE__*/_createVNode("th", null, "Question"),
    /*#__PURE__*/_createVNode("th", { class: "text-nowrap" }, "Times asked"),
    /*#__PURE__*/_createVNode("th", { class: "text-nowrap" }, "Agent"),
    /*#__PURE__*/_createVNode("th", { class: "text-nowrap" }, "Date"),
    /*#__PURE__*/_createVNode("th", { class: "text-end" }, "Actions")
  ])
], -1)
const _hoisted_14 = { class: "fw-semibold text-gray-800" }
const _hoisted_15 = {
  key: 0,
  class: "text-muted fs-7 mt-1"
}
const _hoisted_16 = {
  key: 1,
  class: "text-muted fs-8 mt-1"
}
const _hoisted_17 = { class: "text-nowrap" }
const _hoisted_18 = { class: "text-nowrap" }
const _hoisted_19 = { class: "text-nowrap" }
const _hoisted_20 = { class: "text-end text-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 8,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", null, [
      _createVNode("div", {
        class: _ctx.embedded ? '' : 'card seq-card mb-5'
      }, [
        (!_ctx.embedded)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("h3", _hoisted_2, [
                _createVNode("span", _hoisted_3, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Question-square.svg" })
                ]),
                _hoisted_4
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: _ctx.embedded ? '' : 'card-body py-3'
        }, [
          (_ctx.loadError)
            ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.loadError), 1))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_6, [
            _createVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
            ]),
            _createVNode("div", null, [
              _hoisted_8,
              _createVNode("button", {
                type: "button",
                class: "btn btn-link btn-sm p-0 align-baseline fw-bold",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('navigate', 'knowledge-bases')))
              }, " Knowledge Base "),
              _hoisted_9
            ])
          ]),
          (!_ctx.questions.length)
            ? (_openBlock(), _createBlock("div", _hoisted_10, " No unanswered questions right now. Your AI is covering what prospects ask. "))
            : (_openBlock(), _createBlock("div", _hoisted_11, [
                _createVNode("table", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.questions, (item) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: item.id
                      }, [
                        _createVNode("td", null, [
                          _createVNode("div", _hoisted_14, _toDisplayString(item.questionText), 1),
                          (item.replyText)
                            ? (_openBlock(), _createBlock("div", _hoisted_15, " AI reply: " + _toDisplayString(_ctx.truncateReply(item.replyText)), 1))
                            : _createCommentVNode("", true),
                          (item.knowledgeBaseName)
                            ? (_openBlock(), _createBlock("div", _hoisted_16, " KB: " + _toDisplayString(item.knowledgeBaseName), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("td", _hoisted_17, _toDisplayString(item.occurrenceCount), 1),
                        _createVNode("td", _hoisted_18, _toDisplayString(item.agentName || "—"), 1),
                        _createVNode("td", _hoisted_19, _toDisplayString(_ctx.formatDate(item.createdAt)), 1),
                        _createVNode("td", _hoisted_20, [
                          _createVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-light-primary me-2",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('navigate', 'knowledge-bases')))
                          }, " Add to Knowledge Base "),
                          _createVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-light",
                            disabled: _ctx.dismissingId === item.id,
                            onClick: ($event: any) => (_ctx.dismiss(item))
                          }, _toDisplayString(_ctx.dismissingId === item.id ? "Dismissing..." : "Dismiss"), 9, ["disabled", "onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
        ], 2)
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ]))
}